import React from "react";

interface HighlightedMessageProps {
  message: string;         // raw HTML string
  searchTerm: string;
  className?: string;      // optional additional className
}

const highlightTermInHtml = (html: string, searchTerm: string): string => {
  if (!searchTerm) return html;

  const escapedSearch = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedSearch})`, "gi");

  return html.replace(regex, `<mark style="background: #fff59d;">$1</mark>`);
};

const HighlightedMessage: React.FC<HighlightedMessageProps> = ({
  message,
  searchTerm,
  className = "",
}) => {
  const highlightedHtml = highlightTermInHtml(message, searchTerm);

  const baseClasses = `message-content break-word text-text-primary text-sm rounded-l-lg rounded-b-lg border-transparent border-zinc-300`;
  
  return (
    <div
      dangerouslySetInnerHTML={{ __html: highlightedHtml }}
      className={`${baseClasses} ${className}`}
    />
  );
};

export default HighlightedMessage;
